const filtersInit = (form: HTMLFormElement) => {
  const select = form.querySelector('select');

  select?.addEventListener('change', () => {
    form.submit();
  });
};

export default filtersInit;
